import React from 'react'
import { Seo } from '~/components/molecules/Seo'
import { Screen } from '~/components/screens/about'
import { site } from '~/config'

const Page = () => (
  <>
    <Seo title={`About | ${site.title}`} />
    <Screen />
  </>
)

export default Page
